import { withFormik } from "formik";
import { SurtyGeneralInsuraceInitialValues } from "./initialStatesSurty";
import SurtyGeneralInsuranceForm from '../Steps/SurtyInsuraceFormStep';

export const SurtyGeneralInsuranceFormik = withFormik<any, typeof SurtyGeneralInsuraceInitialValues>({

  mapPropsToValues: () => SurtyGeneralInsuraceInitialValues,

  handleSubmit: (values, bag) => true,

})(SurtyGeneralInsuranceForm);